import { render } from "./SearchForm.vue?vue&type=template&id=ba8aa2c4&scoped=true"
import script from "./SearchForm.vue?vue&type=script&lang=js"
export * from "./SearchForm.vue?vue&type=script&lang=js"

import "./SearchForm.vue?vue&type=style&index=0&id=ba8aa2c4&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba8aa2c4"]])

export default __exports__